import { render, staticRenderFns } from "./InterestButton.vue?vue&type=template&id=6fb8a45d&scoped=true&"
import script from "./InterestButton.vue?vue&type=script&lang=js&"
export * from "./InterestButton.vue?vue&type=script&lang=js&"
import style0 from "./InterestButton.vue?vue&type=style&index=0&id=6fb8a45d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb8a45d",
  null
  
)

export default component.exports